import { render, staticRenderFns } from "./ContractComponent.vue?vue&type=template&id=640bd2ec"
import script from "./ContractComponent.vue?vue&type=script&lang=js"
export * from "./ContractComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports